import { Container, Stack, List, Text, Link, Button } from "basis";
import { usePageTracking, useEventTracking } from "react-event-tracker";

export const GetStarted = ({ setScreen }) => {
  usePageTracking({
    page: {
      pageType: "information-page",
      siteSection: "registration",
      siteSubSection: "",
      pageTitle: "createId",
    },
    user: {
      authenticationStatus: "not logged in",
    },
  });
  const { trackEvent } = useEventTracking();
  return (
    <Container bg="white" width="540" padding="8 8" padding-sm="11 14">
      <Stack gap="6">
        <Text as="h1" textStyle="heading4">
          Let's create a Latitude ID
        </Text>
        <Text>
          Keep track of your accounts 24/7. <br />
          Anywhere, any time, any device.
          <br />
        </Text>
        <Text>
          You will need to supply the following information to create your
          Latitude ID & link your account:
          <br />
        </Text>
        <List>
          <List.Item>Name</List.Item>
          <List.Item>Email address and Mobile number</List.Item>
          <List.Item>Date of birth</List.Item>
          <List.Item>A unique password</List.Item>
          <List.Item>Credit card or Account number</List.Item>
        </List>
        <Button
          width="160"
          onClick={() => {
            setScreen("TermOfUse");
            trackEvent({
              event: {
                category: "cta",
                action: "registration-link",
                location: "Let's create a Latitude ID",
                label: "Get Started",
              },
            });
          }}
        >
          Get Started
        </Button>
        <Container>
          <Link
            href="/login"
            newTab={false}
            onClick={() =>
              trackEvent({
                event: {
                  category: "text-link",
                  action: "internal-link",
                  location: "Let's create a Latitude ID",
                  label: "Already have a Latitude ID? Log in",
                },
              })
            }
          >
            Already have a Latitude ID? Log in
          </Link>
        </Container>
      </Stack>
    </Container>
  );
};
